module.exports = __webpack_public_path__ + "static/media/tab3.980edabb.png";